import React from "react";
import { useTranslation } from "react-i18next";
import { STATUS_STYLES } from "./portalConstants";

export const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const style = STATUS_STYLES[status] || STATUS_STYLES.draft;
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold whitespace-nowrap ${style}`}
      data-testid={`status-badge-${status}`}
    >
      {t(`portal.status.${status}`)}
    </span>
  );
};

export default StatusBadge;
